import { render, staticRenderFns } from "./channelAnalysis.vue?vue&type=template&id=3f5080b9&scoped=true&"
import script from "./channelAnalysis.vue?vue&type=script&lang=js&"
export * from "./channelAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./channelAnalysis.vue?vue&type=style&index=0&id=3f5080b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5080b9",
  null
  
)

export default component.exports